import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { IFindSenderByMail } from "../model/contact-or-person.model";

@Injectable()
export class BladeService {
    bladeProperties: Observable<BladeProperties>;
    private bladePropertiesSubject: ReplaySubject<BladeProperties> = new ReplaySubject(1);
    public currentlySelectedContact: IFindSenderByMail;
    
    constructor() {
        this.bladeProperties = this.bladePropertiesSubject.asObservable();
    }

    public setProperties(props: BladeProperties) {
        this.bladePropertiesSubject.next(props);
    }
}

export interface BladeProperties {
    email: string;
    personName: string;
    companyName: string;
    companyId?: number;
    personId?: number;
    knownContacts?: IFindSenderByMail[];
    audience: AudienceEnum;
    knownContactsCount?: number;
}

export enum AudienceEnum {
    "calendar",
    "inbox",
    "people"
  }